/**
 *  functions.js
 *  Author: Sal
 *  Contains all ajax functions for the application
 */

 import logo_ep from "../img/sidebar-logo-ep.svg";
 import mobile_logo_ep from "../img/ico-osa-laptop.svg";
 import logo_tb from "../img/logo-tb.png";
 import ico_ep from "../img/ico-osa.svg";

 const ax = require("axios");
 let proxyUrl = "/proxy/proxy.php";
 let dataUrl = "/proxy/getDetails.php";
 let ssoUrl = "/proxy/checkSso.php";

 if(window.location.host == 'localhost:3000' || window.location.host == 'dev.exampro.co.uk:3000') {
  proxyUrl = "https://testosa.exampro.co.uk/proxy/proxy.php";
  dataUrl = "https://testosa.exampro.co.uk/proxy/getDetails2.php";
  ssoUrl = "https://testosa.exampro.co.uk/proxy/checkSso.php";
}


 //  check if logged in
 //  @callback - function to pass the retrieved data

const checkSession = (callback) => {

    const result = ax.create({
        withCredentials: true
      });

     result
       .post(proxyUrl, {
         type : "single",
         method: "checkSession",
         classname: "DbOsaLogin"
       })
       .then(data => {
           callback(data.data);
       })
       .catch(er =>  {
            console.log(er);
        })
 }

 const findCenter = (centerNumber, callback) => {

    const result = ax.create({
        withCredentials: true
      });

     result
       .post(proxyUrl, {
         type: "single",
         method: "findCenter",
         classname: "DbOsaLogin",
         params : [centerNumber]
       })
       .then(data => {
           callback(data.data)
       })
       .catch(er =>  {
            console.log(er);
       })
 }



const authenticate = (username, password, callback) => {

    const result = ax.create({
        withCredentials: true
      });

     result
       .post(proxyUrl, {
         type: "single",
         method: "authenticate",
         classname: "DbOsaLogin",
         params : [username, password]
       })
       .then(data => {
         callback(data.data);
       })
        .catch(er =>  {
            console.log(er);
        })
 }

 const getStudentDetails = (filterOne, callback) => {
  const result = ax.create({
      withCredentials: true
    });

   result
     .post(dataUrl, {
       type: "json",
       data : {'filter' : filterOne},
       headers: { "Content-Type": "multipart/form-data" }
     })
     .then(data => {
         callback(data.data)
     })
     .catch(er =>  {
          console.log(er);
     })
}

const getSsoStatus = (callback) => {

    const result = ax.create({
        withCredentials: true
      });

     result
       .get(ssoUrl, {
       })
       .then(data => {
           callback(data.data);
       })
       .catch(er =>  {
            console.log(er);
        })
 }


const getBrand = () => {
    let params = getUrlParams();
    let brandCase = "";
    let exp = false;
    let menu = 'home';
    if (params.menu) menu = params.menu;
    if (params.brand) {

      brandCase = params.brand.toLowerCase();
      if(params.experimental) exp = true;
    }
    if (brandCase !== "ep" && brandCase !== "tb") brandCase = "ep";

    let body = document.body;
    if(brandCase == 'tb') {

          body.classList.add('theme-tb');

          return {
            title: "Testbase",
            logo: logo_tb,
            favicon: "https://app.doublestruck.eu/images/fav/TB.ico",
            key: brandCase,
            experimental : exp,
            navmenu : menu,
            studentLabel : "pupil",
            studentLabelCap : "Pupil",
            brand : "TB"
        }

    }

    if(brandCase == 'ep') {

        body.classList.add('theme-ep');

        return {
          title: "Exampro",
          logo: logo_ep,
          mobileLogo: mobile_logo_ep,
          favicon: ico_ep,
          key: brandCase,
          experimental : exp,
          navmenu : menu,
          studentLabel : "student",
          studentLabelCap : "Student",
          brand : "EP"
        }
    }
  }

 /**
 * get the parameters from the url and then structure into an object.
 * @return {Object} see example above
 */
   const getUrlParams = () => {
    const params = window.location.search;
    if (params) {
      const FIDQueryString = params
        .slice(1, params.length)
        .split("&")
        .reduce((prev, item) => {
          const paramResults = item.split("=");
          prev[paramResults[0]] = paramResults[1];
          return prev;
        }, {});
      return FIDQueryString;
    } else {
      return false;
    }
  };

/**
* Set the favicon to an image that is passed in as a param
* @param {string} img favicon image file link
*/
const setFavicon = (img) => {
  let favicon = document.querySelector('link[rel="shortcut icon"]');

  if (!favicon) {
    favicon = document.createElement("link");
    favicon.setAttribute("rel", "shortcut icon");
    document.head.appendChild(favicon);
  }

  favicon.setAttribute("type", "image/png");
  favicon.setAttribute("href", img);
}


 export {
    authenticate,
    checkSession,
    getBrand,
    getUrlParams,
    findCenter,
    getStudentDetails,
    setFavicon,
    getSsoStatus
 }
